import * as Yup from 'yup';

export const dealerValidationSchema = () =>
  Yup.object({
    dealershipName: Yup.string()
      .required('Dealership name is required')
      .min(2, 'Dealership name must be at least 2 characters'),
    city: Yup.string(),
    state: Yup.string(),
    zipcode: Yup.string().matches(/^\d{5}(-\d{4})?$/, 'Invalid ZIP code'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    fullName: Yup.string()
      .required('Full name is required')
      .min(2, 'Full name must be at least 2 characters'),
    position: Yup.string().required('Title / Position is required'),
    phone: Yup.string()
      .matches(/^\+?[0-9\s]+$/, 'Mobile number must contain only digits')
      .min(10, 'Phone number must be at least 10 digits')
      .required('Mobile number is required.'),
    rooftops: Yup.string(),
    textConsent: Yup.boolean(),
  });

export const nonDealerValidationSchema = () =>
  Yup.object({
    fullName: Yup.string()
      .required('Full name is required')
      .min(2, 'Full name must be at least 2 characters'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    phone: Yup.string()
      .matches(/^\+?[0-9\s]+$/, 'Mobile number must contain only digits')
      .required('Mobile number is required.'),
    category: Yup.string().required('Please select a category'),
    message: Yup.string().min(10, 'Please provide at least 10 characters'),
  });

export const bookDemoFormSchema = () =>
  Yup.object().shape({
    firstName: Yup.string().trim().required('First name is required.'),
    lastName: Yup.string().trim().required('Last name is required.'),
    phone: Yup.string()
      .trim()
      .matches(/^\+?[0-9\s]+$/, 'Mobile number must contain only digits.')
      .min(8, 'Mobile number is too short.')
      .max(15, 'Mobile number is too long.')
      .required('Mobile number is required.'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
  });